import { compose } from 'redux'

import FileUpload from './FileUpload'
import FileUploadConnect from './FileUpload.connect'

export default compose(
  FileUploadConnect
)(FileUpload)
